interface Sortable {
  position: number
}

export function sortByPosition<T extends Sortable>(sortables: T[]) {
  return [...sortables].sort((m1, m2) => m1.position - m2.position)
}
